<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Misc And Other Exam Fees</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="misc_and_other_fees_list" class="elevation-1 mytable" dense
        :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on" small>Add Misc And Other Fees</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-text-field dense rounded outlined v-model="addedItem.misc_and_other_name"
                          label="Please Enter Misc And Other Fees Name" hint="For Ex."></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="addedItem.misc_fee_catogory"
                          item-value="id" :items="misc_category_fees_list" item-text="name"
                          label="Select Misc Fee Category" outlined persistent-hint
                          hint="Please Select Academic Year" />
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field dense rounded outlined v-model="editedItem.misc_and_other_name"
                          label="Please Enter Misc And Other Fees Name" hint="For Ex. "></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.misc_fee_catogory"
                          item-value="editedItem.misc_fee_catogory" :items="misc_category_fees_list" item-text="name"
                          label="Select Misc Fee Category" outlined persistent-hint
                          hint="Please Select Academic Year" />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex == -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" v-if="editedIndex == -1">
                        <v-checkbox dense v-model="addedItem.is_student_specific" color="success" label="Is Student Specific?"></v-checkbox>
                      </v-col>

                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>

                      <v-col cols="12" sm="6" md="6" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.is_student_specific" color="success" label="Is Student Specific?"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.isactive="{ item }">
          <v-switch v-model="item.isactive" small color="success" @change="toggleGroup(item)"></v-switch>
        </template>

         <template v-slot:item.is_student_specific="{ item }">
          <v-switch v-model="item.is_student_specific" small color="success" @change="toggleGroup1(item)"></v-switch>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {

  components: {
    Breadcrumbs,
  },

  data: () => ({
    overlay: false,

    // extraBreadcrumbItems: [
    //   { text: "Misc And Other Exam Fees", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    count: 0,
    errorMsg: {
      misc_and_other_name: false,
    },
    snackbar_msg: "",
    color: "",
    toggle_btn_load: null,
    snackbar: false,
    search: "",
    dialog: false,
    misc_category_fees_list: [],
    catogary: null,
    misc_and_other_fees_list: [],
    headers: [
      {
        text: "Sr. No.",
        align: "left",
        sortable: false,
        value: "sr_no",
      },
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "misc_and_other_name",
      },

      {
        text: "Misc Fee Category",
        align: "left",
        sortable: true,
        value: "misc_fee_catogory",
      },
       {
        text: "Is Student Specific?",
        align: "left",
        sortable: true,
        value: "is_student_specific",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    editedIndex: -1,
    addedItem: {
      misc_and_other_name: "",
      misc_fee_catogory: "",
      isactive: true,
      is_student_specific:false
    },
    editedItem: {
      id: "",
      misc_and_other_name: "",
      misc_fee_catogory: "",
      isactive: true,
      is_student_specific:false
    },
    defaultItem: {
      id: "",
      misc_and_other_name: "",
      misc_fee_catogory: "",
      isactive: true,
      is_student_specific:false
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Misc And Other Fees"
        : "Edit Misc And Other Fees";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    toggleGroup(item) {
      const formData = {
        id: item.id,
        isactive: item.isactive,
      };
      //alert(formData.id+" "+formData.isactive)
      axios
        .post("/AccountingAndFees/toggleGroup", formData)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Action Completed!!!");
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        });
    },
    toggleGroup1(item) {
      const formData = {
        id: item.id,
        is_student_specific: item.is_student_specific,
      };
      axios
        .post("/AccountingAndFees/toggleMiscStudentSpecific", formData)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Action Completed!!!");
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        });
    },
    initializeErrorMsgFalse() {
      this.errorMsg.misc_and_other_name = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AccountingAndFees/getMiscAndOtherFees")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.misc_and_other_fees_list = res.data.misc_and_other_fees_list;
            this.misc_category_fees_list = res.data.misc_category_fees_list;
            //alert(this.misc_and_other_fees_list)
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.misc_and_other_fees_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.fees_component_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.fees_component_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (
          this.editedItem.misc_and_other_name == "" ||
          this.editedItem.misc_and_other_name == null
        ) {
          this.showSnackbar("#b71c1c", "Please Enter Name!!!");
          return false;
        } else {
          if (this.isValidated()) {
            axios
              .post("/AccountingAndFees/editMiscAndOtherFees", this.editedItem)
              .then((res) => {
                if (res.data.msg == "200") {
                  if (res.data.status.code == "SUCCESS") {
                    // Object.assign(
                    //   this.fees_component_list[this.editedIndex],
                    //   this.editedItem
                    // );
                    this.onLoad();
                    this.showSnackbar(
                      "#4caf50",
                      "Fees Installment updated successfully..."
                    ); // show snackbar on success
                  } else {
                    this.onLoad();
                    this.showSnackbar(
                      "#b71c1c",
                      "Fees Installment already present!!!"
                    );
                  }
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
            this.close();
          }
        }
      } else {
        if (
          this.addedItem.misc_and_other_name == "" ||
          this.addedItem.misc_and_other_name == null
        ) {
          this.showSnackbar("#b71c1c", "Please Enter Name!!!");
          return false;
        } else {
          axios
            .post("/AccountingAndFees/saveMiscAndOtherFees", this.addedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                //   this.fees_component_list.push(this.addedItem);
                this.showSnackbar(
                  "#4caf50",
                  "Misc And Other Fees added successfully..."
                ); // show snackbar on success
                this.onLoad();
                // this.addedItem.fees_component_super_master_list = "";
                // this.addedItem.ay = "";
                // this.addedItem.feesComponentcategory = "";
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Misc And Other Fees already present!!!"
                );
                // show snackbar on error
              }
            })

            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.misc_and_other_name) {
        return true;
      } else {
        if (!this.editedItem.misc_and_other_name) {
          this.errorMsg.misc_and_other_name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
